import { useRequest } from 'ahooks';
import { useEffect, useMemo } from 'react';

import {
  getInfluencerSearchHistory,
  getSourceLinkSearchHistory,
  getStockSearchHistory,
} from '../services/search.service';
import { RequestOptions } from '../services/utils';
import { InfluencerSuggestionItem, StockSuggestionItem } from '../shared/types';
import { useUser } from './users';

const useSearchHistoryRaw = (requestOptions: RequestOptions, value: string) => {
  const { data: searchHistoryRaw, run: fetchSearchHistory } = useRequest(
    requestOptions,
    { manual: true }
  );

  const user = useUser();
  useEffect(() => {
    if (user && !value) {
      fetchSearchHistory();
    }
  }, [fetchSearchHistory, user, value]);

  return searchHistoryRaw;
};

export const useStockSearchHistory: (value: string) => StockSuggestionItem[] = (
  value: string
) => {
  const searchHistoryRaw = useSearchHistoryRaw(getStockSearchHistory(), value);

  return useMemo(
    () =>
      (searchHistoryRaw || []).map(item => ({
        stockCode: item.StockCode,
        name_en: item.Name.En,
        name_zh: item.Name.Zh,
        stockType: item.StockType,
      })),
    [searchHistoryRaw]
  );
};

export const useInfluencerSearchHistory: (
  value: string
) => InfluencerSuggestionItem[] = (value: string) => {
  const searchHistoryRaw = useSearchHistoryRaw(
    getInfluencerSearchHistory(),
    value
  );

  return useMemo(
    () =>
      (searchHistoryRaw || []).map(item => ({
        name: item.Name,
      })),
    [searchHistoryRaw]
  );
};

export const useSourceLinkSearchHistory: (
  value: string
) => InfluencerSuggestionItem[] = (value: string) => {
  const searchHistoryRaw = useSearchHistoryRaw(
    getSourceLinkSearchHistory(),
    value
  );

  return useMemo(
    () =>
      (searchHistoryRaw || []).map(item => ({
        tipsSourceLink: item.TipsSourceLink,
      })),
    [searchHistoryRaw]
  );
};
